export default "__VITE_ASSET__BtTJsfyK__"